export default __webpack_public_path__ + "static/media/sorry.c2d76b14.jpg";